// extracted by mini-css-extract-plugin
export var notificationHost = "_me-0";